/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-13 15:41:06
 */
 
import Api from "src/util/api";
import {PageDo, Result, ResultPageDo} from "src/types/base";
export declare namespace MenuConfigDOI {

	export interface RowDataI {
        id: number
        power_name: string
        power_url: string
        type: number
	}

	export interface QueryRowDataParamsI extends PageDo {
		type?: number
	}

	export interface QueryDetailResultI {

	}

	export interface OperateParamsI {
        power_name: string
        power_url: string
        type: 1|2
	}

}
export default class MenuConfigApi {
	/**
	 * 查询列表
	 * @param {MenuConfigDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchList(params: MenuConfigDOI.QueryRowDataParamsI):Promise<ResultPageDo<MenuConfigDOI.RowDataI[]>> {
		return Api.post('/auth_login/login/power/data', {
            type: 0,
            ...params
        })
	}
	/**
	 * 新增
	 * @param {MenuConfigDOI.OperateParamsI} data
	 * @returns {Promise<Result<any>>}
	 */
	static async add(data:MenuConfigDOI.OperateParamsI):Promise<Result<any>> {
		return Api.post('/auth_login/login/power/add', data)
	}


	/**
	 * 删除
	 * @param {Array<number>} data
	 * @returns {Promise<Result<any>>}
	 */
	static async delete(power_id: number):Promise<Result<any>> {
		return Api.post('/auth_login/login/power/delete', {power_id})
	}
}